export default "__VITE_ASSET__D9Zr_CJe__"